import styled, { css } from 'styled-components';

export const Rank = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 38px;
  height: 38px;

  text-align: center;
  background: ${({ theme }) => theme.colors.gray300};
  font-size: ${({ theme }) => theme.fontSize.B2};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.gray900};
`;

export const logoCss = css`
  width: 70px;
  height: 28px;

  & > img {
    width: 40px;
    height: 25px;
  }

  margin-left: 30px;

  ${({ theme }) => theme.media.mobile} {
    width: 37.5px;
    height: 15px;
    margin-left: 10px;

    & > img {
      width: 25px;
      height: 15px;
    }
  }
`;

export const Tag = styled.span`
  font-size: ${({ theme }) => theme.fontSize.C1};
  color: ${({ theme }) => theme.colors.greymint300};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

export const CompanyInfo = styled.div`
  flex: 1;
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  & > p {
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  & > p:first-of-type {
    font-size: ${({ theme }) => theme.fontSize.B3};
    line-height: 1.5;
  }

  & > p:nth-of-type(2) {
    font-size: ${({ theme }) => theme.fontSize.C1};
    color: ${({ theme }) => theme.colors.gray700};
    line-height: 1.5;

    & > ${Tag} {
      margin-left: 5px;
    }
  }
`;

export const RankData = styled.span`
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  font-size: ${({ theme }) => theme.fontSize.B3};

  ${({ theme }) => theme.media.mobile} {
    font-size: ${({ theme }) => theme.fontSize.C1};
  }
`;

export const RankingCardWrapper = styled.article`
  & > a {
    display: flex;
    align-items: center;
    justify-content: left;
    cursor: pointer;

    & > ${Rank} {
      margin: 12px 0 10px 12px;
    }

    & > ${CompanyInfo} {
      margin-left: 30px;
      ${({ theme }) => theme.media.mobile} {
        margin-left: 10px;
      }
    }

    & > ${RankData} {
      margin: auto 19px auto 4px;
      ${({ theme }) => theme.media.mobile} {
        margin: auto 15px auto 5px;
      }
    }
  }

  &:not(:last-child) {
    border-bottom: 1px solid #ebebeb;
  }
`;
